<template>
  <v-container>
    <v-app-bar app dark dense color="secondary">
      <v-toolbar-title>{{ $t("admin.offers.title") }}</v-toolbar-title>
    </v-app-bar>

    <v-row>
      <v-col cols="12">
        <Requests></Requests>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <Offers></Offers>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Offers from "@/components/Admin/Offers.vue";
import Requests from "@/components/Admin/Requests.vue";

export default {
  components: { Offers, Requests },
};
</script>
